module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Valkyrie.fa468a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Valkyrie.jpg
// module id = /FtN
// module chunks = 0